import React from "react";
import { inject, observer } from "mobx-react";
import { Link } from "react-router-dom";
import { Pagination } from "./Pagination";
import { ExactMatchSearchItem } from "./ExactMatchSearchItem";
import { SearchResultsItem } from "./SearchResultsItem";
import { CustomTooltip } from "../tooltip/CustomTooltip";
import { StatefulToolTip } from "react-portal-tooltip";

const DISPLAY_MEMBERS_LIST_ON_EXACT_MATCH = true;
const IS_BIRD_APP = process.env.REACT_APP_ENV === "bird";

@inject(
  "searchStore",
  "navigatorStore",
  "detailViewStore",
  "previewStore",
  "navigationStore"
)
@observer
export class SearchResultsList extends React.Component {
  componentWillUnmount = () => {
    const { setSearchFrameworkExpression } = this.props.searchStore;

    setSearchFrameworkExpression(undefined);
  };

  // TODO preserve?
  displayFrameworkPanel = () => {
    const { getFrameworks, getSearchFrameworkExpression } =
      this.props.searchStore;
    const { getFrameworkListDisplayType, getCurrentFrameworkListDisplayType } =
      this.props.navigatorStore;

    const frameworks = getFrameworks;

    const getUniqueFrameworksCode = (frameworks) => {
      const uniqueFrameworks = [];
      frameworks.forEach((framework) => {
        const code = this.getCodeWithoutRef(framework);
        if (!uniqueFrameworks.includes(code)) {
          uniqueFrameworks.push(code);
        }
      });
      return uniqueFrameworks;
    };
    const frameworkFilterForBIRD = (framework) => {
      const { getPublishedCubes, getUnpublishedCubes } = this.props.searchStore;
      const { isBurgerMenu } = this.props;

      if (framework.frameworkId === "BIRD" && IS_BIRD_APP && !isBurgerMenu)
        return false;
      if (
        (getCurrentFrameworkListDisplayType ===
          getFrameworkListDisplayType.PUBLISHED &&
          getPublishedCubes.some(
            (cube) => cube.frameworkId === framework.frameworkId
          )) || //when in Output reporting Frameworks (published cubes)
        (getCurrentFrameworkListDisplayType ===
          getFrameworkListDisplayType.UNPUBLISHED &&
          getUnpublishedCubes.some(
            (cube) => cube.frameworkId === framework.frameworkId
          ))
      ) {
        //when in Frameworks not yet in BIRD (unpublished cubes)
        return true;
      } else {
        return false;
      }
    };

    const itemSearchFilter = (getSearchFrameworkExpression, item) => {
      if (!getSearchFrameworkExpression) return true;
      return (
        item?.name
          .toLowerCase()
          .includes(getSearchFrameworkExpression.toLowerCase()) ||
        item?.code
          .toLowerCase()
          .includes(getSearchFrameworkExpression.toLowerCase()) ||
        (item.description &&
          item.description
            .toLowerCase()
            .includes(getSearchFrameworkExpression.toLowerCase()))
      );
    };

    const usedFrameworks = IS_BIRD_APP
      ? frameworks.filter((framework) => frameworkFilterForBIRD(framework))
      : frameworks;
    const filteredFrameworks = usedFrameworks.filter((framework) =>
      itemSearchFilter(getSearchFrameworkExpression, framework)
    );

    const ref = [];
    const nonref = [];
    let uniqueCodes = [];

    if (filteredFrameworks && filteredFrameworks.length) {
      uniqueCodes = getUniqueFrameworksCode(filteredFrameworks);
      filteredFrameworks.forEach((framework) => {
        if (framework.maintenanceAgencyId === "ECB") {
          ref.push(framework);
          nonref.push(null);
        } else {
          nonref.push(framework);
          ref.push(null);
        }
      });
    }

    const shouldDisplayPublishedFrameworks =
      getCurrentFrameworkListDisplayType ===
      getFrameworkListDisplayType.PUBLISHED;
    if (this.props.detailViewStore.entityData?.item?.object?.frameworkId) {
      // const selectedFramework = filteredFrameworks.find(
      //   (framework) =>
      //     framework.frameworkId ===
      //     this.props.detailViewStore.entityData?.item?.object?.frameworkId
      // );
    }

    const frameworkList = uniqueCodes.sort().map((code, index) => {
      const ref = filteredFrameworks.find(
        (framework) =>
          framework.maintenanceAgencyId === "ECB" &&
          this.getCodeWithoutRef(framework) === code
      );
      const nonref = filteredFrameworks.find(
        (framework) =>
          framework.maintenanceAgencyId !== "ECB" &&
          this.getCodeWithoutRef(framework) === code
      );
      const target = nonref ? nonref : ref;

      return this.buildHtmlItemForList(
        target,
        ref,
        nonref,
        index,
        shouldDisplayPublishedFrameworks
      );
    });

    return (
      <React.Fragment>
        {frameworkList}
        <p>
          <em>
            {`Showing ${frameworkList.length} of ${
              getUniqueFrameworksCode(usedFrameworks).length
            } results`}
          </em>
        </p>
      </React.Fragment>
    );
  };

  getCodeWithoutRef = (framework) => {
    return framework.code.replace("_REF", "");
  };

  buildHtmlItemForList = (item, ref, nonRef, index, isPublishedFramework) => {
    const { clearEntityData } = this.props.previewStore;
    const { resetNavigationTabs } = this.props.navigationStore;
    const frameworkClassType = nonRef ? "framework-nonref" : "framework-ref";
    const frameworkClassForSdd = IS_BIRD_APP ? "" : "framework-sdd";
    const { isBurgerMenu } = this.props;
    const text = `${item.name}`;
    const textToDisplay = (
      <span className="framework-name">
        {text.substring(0, 25)}
        {text && text.length > 25 ? (
          <div className="text-ellipsis dots">...</div>
        ) : null}{" "}
        ({item.code})
      </span>
    );
    return (
      <div key={item.code + index}>
        <Link
          to={
            !IS_BIRD_APP
              ? `/view/${item.type}/${item.tid}`
              : isPublishedFramework
              ? `/view/${item.type}/${item.tid}?published=true`
              : `/view/${item.type}/${item.tid}?published=false`
          }
          onClick={() => {
            clearEntityData();
            resetNavigationTabs();
          }}
        >
          <div className={`framework ${frameworkClassType}`}>
            {item ? (
              <React.Fragment>
                <div>
                  {isBurgerMenu ? (
                    <StatefulToolTip
                      parent={textToDisplay}
                      position="top"
                      className="cm-cell-tooltip-span"
                    >
                      {text}
                      <div style={{ textAlign: "center" }}></div>
                    </StatefulToolTip>
                  ) : (
                    <span className="framework-name">
                      {`${item.name} (${item.code}) `}{" "}
                      <CustomTooltip
                        type={item.code}
                        placement={"right"}
                        content={item.description}
                      />{" "}
                    </span>
                  )}
                </div>
                <div>
                  {ref && !nonRef && (
                    <span
                      className={`ref-framework-new ${frameworkClassForSdd}`}
                    >
                      {!isBurgerMenu ? "Reference" : "REF"}
                    </span>
                  )}
                  {nonRef ? (
                    <div>
                      {ref && (
                        <Link
                          onClick={() => {
                            clearEntityData();
                            resetNavigationTabs();
                          }}
                          to={
                            !IS_BIRD_APP
                              ? `/view/${ref.type}/${ref.tid}`
                              : isPublishedFramework
                              ? `/view/${ref.type}/${ref.tid}?published=true`
                              : `/view/${ref.type}/${ref.tid}?published=false`
                          }
                        >
                          <span className="ref-framework-new">
                            {!isBurgerMenu ? "Reference" : "REF"}
                          </span>
                        </Link>
                      )}
                      <span
                        className={`nonref-framework ${frameworkClassForSdd}`}
                      >
                        {!isBurgerMenu ? "Non-Reference" : "NON-REF"}
                      </span>
                    </div>
                  ) : (
                    <span className="framework-link-placeholder"></span>
                  )}
                </div>
              </React.Fragment>
            ) : null}
          </div>
        </Link>
      </div>
    );
  };

  exactMatch = (item) => {
    const { getSearchQuery } = this.props.searchStore;
    const isExactMatch =
      (getSearchQuery.toLowerCase() === item.name?.toLowerCase() ||
        getSearchQuery.toLowerCase() === item.code?.toLowerCase()) &&
      item.type === "Variable";
    return isExactMatch;
  };

  render() {
    const {
      getCurrentPage,
      setPage,
      setPerPage,
      fetchSearchResults,
      getSearchQuery,
      getSearchResults,
      getPerPage,
      getTotalResults,
    } = this.props.searchStore;

    const { hidePagination, isHomePage } = this.props;

    const displayFrom = (getCurrentPage - 1) * getPerPage + 1;
    let displayTo = getCurrentPage * getPerPage;
    if (displayTo > getTotalResults) {
      displayTo = getTotalResults;
    }

    return (
      <React.Fragment>
        {!hidePagination ? (
          <h5 className="search-results-stats">
            <p>
              {`Results are sorted by type, reference objects are above non-reference objects, matches in codes are above matches in names and descriptions.`}
              <br></br>
              {`Search is performed in context of the chosen profile. You can use wildcard * to substitute any sequence of characters.`}
            </p>
            <p>
              {`Found ${getTotalResults} items. Displaying items ${displayFrom} - ${displayTo}.`}
            </p>
          </h5>
        ) : (
          ""
        )}

        {!hidePagination ? (
          <Pagination
            currentPage={getCurrentPage}
            setCurrentPage={setPage}
            setPerPage={setPerPage}
            perPage={getPerPage}
            fetchSearchResults={fetchSearchResults}
            searchQuery={getSearchQuery}
            totalResults={getTotalResults}
          />
        ) : (
          ""
        )}

        <div className="search-results-list">
          {/* {isHomePage
            ? this.displayFrameworkPanel()
            : getSearchResults.results.map((item, index) => (
              DISPLAY_MEMBERS_LIST_ON_EXACT_MATCH && this.exactMatch(item) ?
                  <ExactMatchSearchItem item={item} key={index} />
                : <SearchResultsItem {...item} key={index} />

              ))} */}
          {isHomePage
            ? this.displayFrameworkPanel()
            : getSearchResults.results.map((item, index) =>
                // DISPLAY_MEMBERS_LIST_ON_EXACT_MATCH && item.type !=="Cube" && item.type !=="Member"?
                DISPLAY_MEMBERS_LIST_ON_EXACT_MATCH && this.exactMatch(item) ? (
                  <ExactMatchSearchItem
                    item={item}
                    key={index}
                    openMemberPanel={index === 0 ? true : false}
                  />
                ) : (
                  <SearchResultsItem {...item} key={index} />
                )
              )}
        </div>

        {!hidePagination ? (
          <Pagination
            dropup={true}
            currentPage={getCurrentPage}
            setCurrentPage={setPage}
            setPerPage={setPerPage}
            perPage={getPerPage}
            fetchSearchResults={fetchSearchResults}
            searchQuery={getSearchQuery}
            totalResults={getTotalResults}
          />
        ) : (
          ""
        )}
      </React.Fragment>
    );
  }
}
